<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <!-- 中间 -->
        <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">TICKET</div>
          </div>
          <div class="chinese">购票</div>
        </div>

        <!-- 底部 -->
        <div class="footerMenu" style="margin-left:1.8229vw">
          <div
            :class="classNameD"
            @mouseover="classNameD = 'colAHover'"
            @mouseout="classNameD = 'colA'"
            @click = "towailianA"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">旅</div>
            <div class="chaFont" style="margin-top:0px">行</div>
            <div class="chaFont" style="margin-top:0px">社</div>
            <div class="chaFont" style="margin-top:0px">购</div>
            <div class="chaFont" style="margin-top:0px">票</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameA"
            @mouseover="classNameA = 'colAHover'"
            @mouseout="classNameA = 'colA'"
            @click = "towailianB"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">散</div>
            <div class="chaFont">客</div>
            <div class="chaFont">购</div>
            <div class="chaFont">票</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
import  "@/css/switch.css"
import {getLinkList} from "@/api/common";
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA",
      wailianA:'',
      wailianB:''
    };
  },
  mounted(){
   this.getInfoFunction()
  },
  methods: {
    async getInfoFunction() {
      const { code, data } = await getLinkList();
      if (code == 200) {
        this.wailianA = data[0].url
        this.wailianB = data[1].url
      }
    }, 
    towailianA(){
      window.open(this.wailianA, '_blank')
    },
    towailianB(){
      window.open(this.wailianB, '_blank')
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ticket/ticketSwitch.vue